import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import GenesisHero from "../../../src/components/Main/Landing/images/hero-genesis.png";
import { LineWeight } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  heroSection: {
    display: 'flex',
    justifyContent: 'center',
    padding: '4px 5% 0',
    backgroundColor: '#0d0d0d',
    marginBottom: '60px',
    [theme.breakpoints.down('sm')]: {
      padding: '30px 20px 0',
      marginBottom: '36px',
    }
  },
  heroContent: {
    maxWidth: 1314,
    width: '100%',
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'space-between',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: '40px',
    }
  },
  heroTextContainer: {
    flex: 1,
    maxWidth: '700px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingBottom: '80px',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 0,
      alignItems: 'center',
      textAlign: 'center',
    }
  },
  heroTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: '64px',
    fontWeight: 400,
    marginBottom: '12px',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('md')]: {
      whiteSpace: 'normal',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '36px',
      lineHeight: '100%',
    }
  },
  heroSubtitle: {
    fontSize: '18px',
    color: '#FFFFFF',
    lineHeight: '27px',
    marginBottom: '30px',
    fontFamily: "'Roboto', sans-serif",
    fontWeight: 200,
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      fontWeight: 200,
      lineHeight: '24px',
      marginBottom: '16px',
    }
  },
  breadcrumbs: {
    fontSize: '16px',
    fontWeight: 400,
    gap: '8px',
    display: "flex",
    alignItems: "center",
    color: '#FFFFFF',
    '& span': {
      color: '#FE5A97',
      fontWeight: 500,
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: '10px',
      fontSize: '16px',
      marginBottom: '36px',
    }
  },
  heroImageContainer: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      // justifyContent: 'center',
      display: 'none',
    }
  },
  heroImage: {
    maxWidth: '100%',
    height: 'auto',
    objectFit: 'contain',
    display: 'block',
  },
}));

export const GenesisHeroSection = () => {
  const classes = useStyles();
  return (
    <Box className={classes.heroSection}>
      <Box className={classes.heroContent}>
        <Box className={classes.heroTextContainer}>
          <Typography className={classes.heroTitle}>
            Meet the Genesis Collection
          </Typography>
          <Typography className={classes.heroSubtitle}>
            The Genesis Collection features SugarCribs founding creators. Discover the talent, creativity, and exclusivity that define our community.
          </Typography>
          <Typography className={classes.breadcrumbs}>
            Home
            <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L5 5L1 9" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span>Genesis Collection</span>
          </Typography>
        </Box>
        <Box className={classes.heroImageContainer}>
          <img
            src={GenesisHero}
            alt="Genesis Collection Placeholder"
            className={classes.heroImage}
          />
        </Box>
      </Box>
    </Box>
  );
};
